import { ActionConfirmDialog } from './action-confirm-dialog.component';

export type AdSetArchiveDialogProps = {
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
  adSetName: string | null;
};

export const AdSetArchiveDialog = ({
  onClose,
  onConfirm,
  loading,
  adSetName,
}: AdSetArchiveDialogProps) => {
  const message = `This action will archive Ad Set${adSetName ? ` "${adSetName}"` : ''}.`;

  return (
    <ActionConfirmDialog
      onClose={onClose}
      onConfirm={onConfirm}
      message={message}
      confirmButtonColor='error'
      confirmButtonDisabled={loading}
    />
  );
};
